interface CartElement extends Element {
  updateQuantity: (index: string, quantity: number, event: Event, itemKey: string) => void;
  removeWarrantyAndItemQuantity: (
    index: string,
    itemKey: string,
    warrantyKey: string,
    event: Event,
    variantId: string,
  ) => void;
}
export default class CartRemoveButton extends HTMLElement {
  private cartItems: CartElement | null = null;
  private itemKey: string | null = null;

  constructor() {
    super();
    this.initializeElements();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  private initializeElements(): void {
    this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    this.itemKey = this.dataset.itemKey;
  }

  private handleClick(event: Event): void {
    event.preventDefault();

    if (!this.cartItems) return;

    const relatedWarrantyItems = Array.from(this.cartItems.querySelectorAll('[data-warranty-item="true"]')).filter(
      (item) => item.getAttribute('data-linked-item-key') === this.itemKey,
    );

    try {
      if (relatedWarrantyItems.length > 0) {
        const warrantyKeys: string[] = [];
        const variantId = this.dataset.variantId || '';
        relatedWarrantyItems.forEach((item) => {
          const variantId = item.getAttribute('data-warranty-id');
          if (variantId) {
            warrantyKeys.push(this.getWarrantyItem(variantId));
          }
        });
        if (typeof this.cartItems?.updateQuantity === 'function') {
          const itemIndex = this.dataset.index;
          this.cartItems.removeWarrantyAndItemQuantity(itemIndex, this.itemKey, warrantyKeys, event, variantId);
        }
      } else {
        this.removeCartItem(event);
      }
    } catch {
      const lineItemErrors = document.querySelectorAll(`#CartItem-LineItemError-${this.dataset.index}`);
      lineItemErrors.forEach((lineItemError) => {
        const errorText = lineItemError?.querySelector('.cart-item__error-text');
        if (errorText) {
          errorText.textContent = 'There was a problem removing the warranty item';
        }
      });
    }
  }

  private removeCartItem(event: Event): void {
    const index = this.dataset.index;

    if (!this.itemKey) {
      return;
    }

    if (typeof this.cartItems?.updateQuantity === 'function') {
      this.cartItems.updateQuantity(index, 0, event, this.itemKey);
    }
  }

  private getWarrantyItem(variantId: string): string | null {
    const hiddenWarrantyItem =
      document.querySelector(`[data-warranty-id="${variantId}"]`) || document.querySelector(`[id*="${variantId}"]`);

    if (!hiddenWarrantyItem) {
      return null;
    }

    const warrantyKey = hiddenWarrantyItem.dataset.itemKey;

    if (!warrantyKey || !this.itemKey) {
      return null;
    }
    return warrantyKey;
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}
